import { Injectable, EventEmitter } from '@angular/core';
import dayjs from 'dayjs';

/** Payload for shared date-range selection events (subheader, system view, etc.). */
export interface DateRangeSelection {
  from?: Date;
  to?: Date;
  id?: string;
}

@Injectable({
  providedIn: 'root'
})
export class DateService {

  fromDate = new Date();
  dateRange: DateRangeSelection = {
    // TODO: Commented to load all by default
    from: dayjs().subtract(30, 'day').startOf('day').toDate(),
    to: dayjs().toDate(),
    id: 'last30days'
  }
  dateRangeSelectionChanged = new EventEmitter<DateRangeSelection>();
  unitChanged = new EventEmitter<any[]>();
  facilityChanged = new EventEmitter<any>();
  plantChanged = new EventEmitter<any>();
  setEmptyUnit = new EventEmitter<any>();
  showGISView = new EventEmitter<boolean>();

  facilityData:any = {}
  constructor() { }

  getDatesForPreset(presetId: string): DateRangeSelection {
    const now = dayjs();
    let range: DateRangeSelection = { id: presetId };

    if (presetId === 'today') {
      range.from = now.startOf('day').toDate();
      range.to = now.toDate();
    } else if (presetId === 'last24hours') {
      range.from = now.subtract(24, 'hour').toDate();
      range.to = now.toDate();
    } else if (presetId === 'last7days') {
      range.from = now.subtract(7, 'day').startOf('day').toDate();
      range.to = now.toDate();
    } else if (presetId === 'last30days') {
      range.from = now.subtract(30, 'day').startOf('day').toDate();
      range.to = now.toDate();
    } else if (presetId === 'last6months') {
      range.from = now.subtract(6, 'month').startOf('day').toDate();
      range.to = now.toDate();
    } else if (presetId === 'last12months') {
      range.from = now.subtract(12, 'month').startOf('day').toDate();
      range.to = now.toDate();
    } else if (presetId === 'all') {
      // No date bounds — return just the ID
    } else if (presetId === 'last1hour') {
      range.from = now.subtract(1, 'hour').toDate();
      range.to = now.toDate();
    } else if (presetId === 'last4hours') {
      range.from = now.subtract(4, 'hour').toDate();
      range.to = now.toDate();
    } else if (presetId === 'last8hours') {
      range.from = now.subtract(8, 'hour').toDate();
      range.to = now.toDate();
    } else if (presetId === 'last12hours') {
      range.from = now.subtract(12, 'hour').toDate();
      range.to = now.toDate();
    } else if (presetId === 'yesterday') {
      range.from = now.subtract(1, 'day').startOf('day').toDate();
      range.to = now.subtract(1, 'day').endOf('day').toDate();
    } else if (presetId === 'thisWeek') {
      const day = now.day(); // 0 Sun … 6 Sat; match dashboard Monday-start week
      const mondayOffset = (day + 6) % 7;
      range.from = now.subtract(mondayOffset, 'day').startOf('day').toDate();
      range.to = now.toDate();
    } else if (presetId === 'previousWeek') {
      const day = now.day();
      const mondayOffset = (day + 6) % 7;
      const thisMonday = now.subtract(mondayOffset, 'day').startOf('day');
      range.from = thisMonday.subtract(7, 'day').toDate();
      range.to = thisMonday.subtract(1, 'day').endOf('day').toDate();
    } else if (presetId === 'last15days') {
      range.from = now.subtract(15, 'day').startOf('day').toDate();
      range.to = now.toDate();
    } else if (presetId === 'thisMonth') {
      range.from = now.startOf('month').toDate();
      range.to = now.toDate();
    } else if (presetId === 'previousMonth') {
      range.from = now.subtract(1, 'month').startOf('month').toDate();
      range.to = now.subtract(1, 'month').endOf('month').toDate();
    } else if (presetId === 'last3months') {
      range.from = now.subtract(3, 'month').startOf('day').toDate();
      range.to = now.toDate();
    } else if (presetId === 'thisYear') {
      range.from = now.startOf('year').toDate();
      range.to = now.toDate();
    } else if (presetId === 'previousYear') {
      range.from = now.subtract(1, 'year').startOf('year').toDate();
      range.to = now.subtract(1, 'year').endOf('year').toDate();
    }

    return range;
  }
}
